<template>
  <div class="heatmap-container">
    <div>
      <draggable tag="v-layout" v-model="draggableCards"
       class="heatmap-container-heatmaps"
      >
        <template>
          <v-card v-for="trackGroup in trackGroups"
            :key="trackGroup"
            elevation="0"
            class="mx-auto"
          >
          <!-- <div > -->
            <div 
            
              :id="generateDivId(trackGroup)">
            </div>
          <!-- </div> -->
          </v-card>
        </template>
      </draggable>
    </div>
    <heatmap-legend :studySelected="this.studySelected" />
  </div>
</template>

<script>
import heatmap from '../../plotly/heatmap'
import HeatmapLegend from './HeatmapLegend.vue'
import draggable from 'vuedraggable'

export default {
    components: { 
      draggable, 
      HeatmapLegend 
    },
    name: "heatmap-container",

    props: ['view', 'studySelected'],

    data() {
      return {
      }
    },

    computed: {
      categoryTracks() { 
        console.log('HeatmapContainer category', this.$store.state.Heatmap_categoryTracksFiltered[this.studySelected])
        console.log('HeatmapContainer category length', this.$store.state.Heatmap_categoryTracksFiltered[this.studySelected]['Ungrouped'].length)
        
        return this.$store.state.Heatmap_categoryTracksFiltered[this.studySelected] 
      },
      trackGroups() { return this.$store.state.Heatmap_trackGroups },
      draggableCards: {
        get() {
          return this.trackGroups
        },
        set(Heatmap_trackGroups) {
          this.$store.dispatch(
                'setHeatmapTrackGroups', 
                { Heatmap_trackGroups }
              )
        }
      },
      genes() { return this.$store.state.Heatmap_genes }, 
      shownDataTypes() { return this.$store.state.Heatmap_shownDataTypes },
      trackData() { return this.$store.state.Heatmap_data }, 
      sampleOrder() { 
        console.log('HeatmapContainer sampleOrder', this.$store.state.Heatmap_sampleOrder[this.studySelected])
        return this.$store.state.Heatmap_sampleOrder[this.studySelected] }, 
    },

    watch: {
      categoryTracks() { this.renderHeatmap() },
      trackData() { this.renderHeatmap() },
      sampleOrder() { this.renderHeatmap() },
      shownDataTypes() { this.renderHeatmap() },
      studySelected() { this.renderHeatmap() },
    },

    methods: {
      trackGroupLength(trackGroup) {
        console.log('trackGroupLength', this.categoryTracks[trackGroup].length)
        return this.categoryTracks[trackGroup].length > 0 
      },
      generateDivId(trackGroup) { return `plotly-heatmap-${trackGroup}` },
      renderHeatmap() {
        this.trackGroups.forEach((trackGroup) => {
          let plot = heatmap({
            categoryTracks: this.categoryTracks,
            trackGroup,
            genes: this.genes,
            trackData: this.trackData,
            sampleOrder: this.sampleOrder,
            shownDataTypes: this.shownDataTypes,
            studySelected: this.studySelected
          })
  
          let that = this
          
          if (plot) {
            plot.on('plotly_hover', function(data) {
  
              const sample = data.points[0].x
              const track = data.points[0].y
  
              if (track in that.trackData) {
                const value = that.trackData[track].data[sample]
                var hoverValue = value.toFixed(3)
                if (value === 2) {
                  hoverValue = "Mutation"
                } else if (value === -2) (
                  hoverValue = "Wildtype"
                )
                data.points[0].fullData.hovertemplate = 
                  `${sample}<br>${track}: ${hoverValue}<br><extra></extra>`
              } else {
                data.points[0].fullData.hovertemplate = 
                  `<extra></extra>`
              }
            })
          }
        })
      }
    },
}
</script>

<style>
.heatmap-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    overflow: scroll;
    margin-top: 30px;
}

.heatmap-container-heatmaps {
    width: 100%;
    display: flex;
    flex-direction: column;
}


</style>